import { Contract } from '@domain/Contract'
import { solarSalesAxios } from '@infrastructure/apiService'

function factory(service) {
  return {
    async getContract(cups) {
      // on-demand: the signature URL only comes from revealSignatureLink, which records every delivery
      const { data } = await service.get(`/${cups}/contract-status`, {
        params: { signatureLink: 'on-demand' },
      })

      return Contract(data)
    },
    async revealSignatureLink(cups) {
      const { data } = await service.post(`/${cups}/contract/signature-link`)

      return data.signatureUrl
    },
    async submitManualSignature(cups, file) {
      const formData = new FormData()
      formData.append('file', file)
      await service.post(`/${cups}/contract/manual-signature`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    },
  }
}

export default factory(solarSalesAxios)
